module.exports = __webpack_public_path__ + "img/image_desktop.fd60d87e.png";